import { Navigate, Route, Routes } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../../context/AuthContext";
import { AdminLogin } from "./AdminLogin";
import { AdminShell } from "./AdminShell";
import { AdminDashboard } from "./AdminDashboard";
import { AdminNewsPage } from "./AdminNewsPage";
import { AdminContentPage } from "./AdminContentPage";
import { AdminUsersPage } from "./AdminUsersPage";
import { AdminHistoryPage } from "./AdminHistoryPage";
import { AdminTeamsPage } from "./AdminTeamsPage";
import { AdminToastProvider } from "../../context/AdminToastContext";
import { hasAdminPermission, type AdminPermission } from "../../lib/adminPermissions";
import { AdminAuthSkeleton } from "../../components/LoadingSkeleton";

export function AdminRouter() {
  return <AdminToastProvider><AdminRouterContent /></AdminToastProvider>;
}

function AdminRouterContent() {
  const { session, isAdmin, adminRole, loading } = useAuth();
  if (loading) return <AdminAuthSkeleton />;
  if (!session || !isAdmin) return <AdminLogin unauthorized={Boolean(session && !isAdmin)} />;

  return (
    <Routes>
      <Route element={<AdminShell />}>
        <Route index element={<AdminDashboard />} />
        <Route path="news" element={<PermissionRoute role={adminRole} permission="news:manage"><AdminNewsPage /></PermissionRoute>} />
        <Route path="inhalte" element={<PermissionRoute role={adminRole} permission="content:manage"><AdminContentPage /></PermissionRoute>} />
        <Route path="mannschaften" element={<PermissionRoute role={adminRole} permission="content:manage"><AdminTeamsPage /></PermissionRoute>} />
        <Route path="team" element={<PermissionRoute role={adminRole} permission="users:manage"><AdminUsersPage /></PermissionRoute>} />
        <Route path="historie" element={<PermissionRoute role={adminRole} permission="history:view"><AdminHistoryPage /></PermissionRoute>} />
        <Route path="*" element={<Navigate replace to="/admin" />} />
      </Route>
    </Routes>
  );
}

function PermissionRoute({ role, permission, children }: { role: "owner" | "admin" | "editor" | null; permission: AdminPermission; children: ReactNode }) {
  return hasAdminPermission(role, permission) ? children : <Navigate replace to="/admin" />;
}
